<div class="error-page">
  <div class="header p-2">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h1>{{ "errorPage.header" | translate }}</h1>
        </div>
      </div>
    </div>
  </div>

  <div class="body p-2">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <p>{{ "errorPage.text" | translate }}</p>

          <vw-button
            [primary]="true"
            [text]="'errorPage.tryAgain' | translate"
            (click$)="tryAgain()"
          ></vw-button>
        </div>
      </div>
    </div>
  </div>
</div>
